import React from "react"
import { useSolutionLevelScheduledReportExportContext } from "contexts/SolutionLevelScheduledReportExportContext"
import {
  SELECT_REPORTABLE_FIELD_TYPE,
  SELECT_CSV_REPORTABLE_FIELD_TYPE,
  MULTI_SELECT_REPORTABLE_FIELD_TYPE,
} from "utils/reportableFieldHelpers"
import { MultiSelect } from "shared/multiSelects"

const SELECT_REPORTABLE_FIELD_TYPES = [
  SELECT_REPORTABLE_FIELD_TYPE,
  SELECT_CSV_REPORTABLE_FIELD_TYPE,
  MULTI_SELECT_REPORTABLE_FIELD_TYPE,
]

const ReportableFieldSelectAnswerFiltersReportableFieldSelect = () => {
  const {
    reportableFields,
    reportableFieldSelectAnswerFilters,
    toggleReportableFieldSelectAnswerFilterReportableFieldId,
  } = useSolutionLevelScheduledReportExportContext()

  const selectReportableFields = reportableFields.filter((rf) => SELECT_REPORTABLE_FIELD_TYPES.includes(rf.questionType) && rf.options?.length > 0)

  if (selectReportableFields.length === 0) {
    return (
      <p>There are no select reportable fields in the solution associated with this report.</p>
    )
  }

  const selectedReportableFieldIds = reportableFieldSelectAnswerFilters.map((f) => f.reportableFieldId)

  const handleChange = (ids) => {
    const added = ids.find((id) => !selectedReportableFieldIds.includes(id))
    const removed = selectedReportableFieldIds.find((id) => !ids.includes(id))

    if (added) toggleReportableFieldSelectAnswerFilterReportableFieldId(added)
    if (removed) toggleReportableFieldSelectAnswerFilterReportableFieldId(removed)
  }

  return (
    <MultiSelect
      className="!w-full bordered-base-input"
      label="select reportable fields to filter by"
      onChange={handleChange}
      options={selectReportableFields.map((rf) => ({ label: rf.name, value: rf.id }))}
      placeholder="Select reportable fields..."
      searchable
      values={selectedReportableFieldIds}
    />
  )
}

export default ReportableFieldSelectAnswerFiltersReportableFieldSelect
